import { api } from './api';

/* Mirrors Eduvora.Application.Dashboards. Money is paise (bigint server-side) — never
   do arithmetic on these in the UI beyond dividing by 100 for display. */

export interface TopperRow {
  studentId: string;
  studentName: string;
  percentage: number;
  termName: string;
}

export interface ClassRow {
  academicClassId: string | null;
  classLabel: string;
  strength: number;
  billedPaise: number;
  collectedPaise: number;
  outstandingPaise: number;
  collectedPct: number;
  studentsWithDues: number;
  overdueStudents: number;
  attendanceHeld: number;
  attendancePresent: number;
  /** ⚠ null means nobody marked attendance in this window — NOT 0%. Render "—". */
  attendancePct: number | null;
  toppers: TopperRow[];
}

export interface CollectionPoint {
  month: string;
  billedPaise: number;
  collectedPaise: number;
}

export interface CommandCenterTotals {
  students: number;
  classes: number;
  staff: number;
  billedPaise: number;
  collectedPaise: number;
  outstandingPaise: number;
  overduePaise: number;
  collectedPct: number;
  studentsWithDues: number;
  attendancePct: number | null;
  attendanceHeld: number;
  attendancePresent: number;
}

export interface InstitutionOption {
  id: string;
  name: string;
  kind: string;
}

export interface CommandCenter {
  academicYear: string | null;
  availableYears: string[];
  institutionId: string | null;
  institutions: InstitutionOption[];
  attendanceFrom: string;
  attendanceTo: string;
  totals: CommandCenterTotals;
  classes: ClassRow[];
  months: CollectionPoint[];
  caveat: string | null;
}

export interface CommandCenterQuery {
  institutionId?: string | null;
  year?: string | null;
  from?: string | null;
  to?: string | null;
}

export const commandCenterApi = {
  load: (q: CommandCenterQuery = {}) => {
    const p = new URLSearchParams();
    if (q.institutionId) p.set('institutionId', q.institutionId);
    if (q.year) p.set('year', q.year);
    if (q.from) p.set('from', q.from);
    if (q.to) p.set('to', q.to);
    const qs = p.toString();
    return api.get<CommandCenter>(`/api/dashboard/command-center${qs ? '?' + qs : ''}`);
  },
};
